import { Injectable, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import * as CreditActions from '../actions/credits.actions';
import { CreditsService } from '../../services/credits.service';
@Injectable({ providedIn: 'root' })
export class CreditsEffects {
    private creditsService = inject(CreditsService);
    private actions$ = inject(Actions);

    loadUserCredits$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreditActions.loadUserCredits),
            switchMap(({userId}) =>
                this.creditsService.getUserCredits(userId).pipe(
                    map(credits => CreditActions.loadUserCreditsSuccess({ credits })),
                    catchError(error => of(CreditActions.loadUserCreditsFailure({ error })))
                )
            )
        )
    );

    loadUserCreditsSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(CreditActions.loadUserCreditsSuccess),
                tap(({ credits }) => {
                })
            ),
        { dispatch: false }
    );
    loadUserCreditsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(CreditActions.loadUserCreditsFailure),
                tap(({ error }) => {
                })
            ),
        { dispatch: false }
    );
}


